import { c as _c } from "react/compiler-runtime";
/* eslint-disable import/no-unresolved */
import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
import loadable from '@loadable/component';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import useScreen from 'hooks/useScreen';
import CustomCarouselArrows from './CustomCarouselArrows';
const BEFORE_SLIDE_FN_DEFAULT = () => {};
const AFTER_SLIDE_FN_DEFAULT = () => {};
const Carousel = loadable(() => import('./WrappedCarousel'));

// TODO: Investigate why forwardRef is needed here
const ForwardRefCarousel = React.forwardRef((props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Carousel carouselRef={ref} {...props} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
const NewSliderComponent = t0 => {
  const $ = _c(28);
  const {
    children,
    deviceOverride: t1,
    disableSliding,
    fabricGridControls: t2,
    finalVisibleSlides,
    isMobileMaterialSwatches: t3,
    navType,
    variant,
    beforeSlideFn: t4,
    afterSlideFn: t5
  } = t0;
  const deviceOverride = t1 === undefined ? false : t1;
  const fabricGridControls = t2 === undefined ? false : t2;
  const isMobileMaterialSwatches = t3 === undefined ? false : t3;
  const beforeSlideFn = t4 === undefined ? BEFORE_SLIDE_FN_DEFAULT : t4;
  const afterSlideFn = t5 === undefined ? AFTER_SLIDE_FN_DEFAULT : t5;
  const carouselRef = useRef(null);
  const {
    isMobile
  } = useScreen();
  const showLeftAndRightPartially = finalVisibleSlides < 2 && finalVisibleSlides > 1;
  const finalSlides = children;
  let t6;
  bb0: {
    if (deviceOverride) {
      t6 = finalVisibleSlides;
      break bb0;
    }
    if (finalVisibleSlides) {
      t6 = finalVisibleSlides;
      break bb0;
    }
    const defaultSlides = isMobile ? 2 : 4;
    t6 = Math.min(finalSlides.length, defaultSlides);
  }
  const visibleSlides = t6;
  if (!finalSlides.length) {
    const t7 = variant === "material-swatches-sidebar";
    const t8 = variant === "blog-slider";
    let t9;
    if ($[0] !== t7 || $[1] !== t8) {
      t9 = classNames("mt-5 [&_.slider]:min-h-[1px] [&_.slider]:m-auto [&_.slider-slide>img]:object-cover components [&_.slider-control-bottomcenter]:w-full", {
        "!mt-0": t7,
        "!min-h-[250px] max-[400px]:!min-h-[400px]": t8
      });
      $[0] = t7;
      $[1] = t8;
      $[2] = t9;
    } else {
      t9 = $[2];
    }
    let t10;
    if ($[3] !== t9) {
      t10 = <div className={t9} />;
      $[3] = t9;
      $[4] = t10;
    } else {
      t10 = $[4];
    }
    return t10;
  }
  const hideNav = visibleSlides >= finalSlides.length || navType === "";
  const t7 = !isMobileMaterialSwatches;
  const t8 = variant === "material-swatches-sidebar";
  const t9 = variant === "blog-slider";
  let t10;
  if ($[5] !== fabricGridControls || $[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
    t10 = classNames("NewSliderComponent components [&_.slider-control-bottomcenter]:w-full", {
      "[&_.slider-control-centerleft]:items-stretch [&_.slider-control-centerleft]:!bottom-0 [&_.slider-control-centerleft]:flex [&_.slider-control-centerleft]:justify-stretch [&_.slider-control-centerleft]:absolute [&_.slider-control-centerleft]:!top-0 [&_.slider-control-centerleft]:![transform:none] [&_.slider-control-centerleft]:!w-[calc(9%_-_9px)] [&_.slider-control-centerright]:items-stretch [&_.slider-control-centerright]:!bottom-0 [&_.slider-control-centerright]:flex [&_.slider-control-centerright]:justify-stretch [&_.slider-control-centerright]:absolute [&_.slider-control-centerright]:!top-0 [&_.slider-control-centerright]:![transform:none] [&_.slider-control-centerright]:!w-[calc(9%_-_9px)]": fabricGridControls,
      "mt-5 [&_.slider]:min-h-[1px] [&_.slider]:m-auto [&_.slider-slide>img]:object-cover [&_.slider-control-centerleft]:!left-0 [&_.slider-control-centerright]:!right-0": t7,
      "!mt-0": t8,
      "pt-1 !mt-0": t9
    });
    $[5] = fabricGridControls;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== hideNav || $[11] !== isMobile || $[12] !== variant) {
    t11 = variant === "blog-slider" && !isMobile && !hideNav && <div className="w-full flex justify-end gap-2 mb-2 mr-1"><button type="button" className="group/SliderButton w-[50px] h-[50px] flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 transition-all hover:border-brand bg-transparent [&_svg_path]:fill-gray" aria-label="Previous slide" onClick={() => {
        carouselRef.current?.goBack();
      }}><IconArrowLeftWhite /></button><button type="button" className="group/SliderButton w-[50px] h-[50px] flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 transition-all hover:border-brand bg-transparent [&_svg_path]:fill-gray" aria-label="Next slide" onClick={() => {
        carouselRef.current?.goForward();
      }}><IconArrowRightWhite /></button></div>;
    $[10] = hideNav;
    $[11] = isMobile;
    $[12] = variant;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== afterSlideFn || $[15] !== beforeSlideFn || $[16] !== disableSliding || $[17] !== finalSlides || $[18] !== finalVisibleSlides || $[19] !== isMobile || $[20] !== isMobileMaterialSwatches || $[21] !== showLeftAndRightPartially || $[22] !== variant) {
    t12 = isMobile && !isMobileMaterialSwatches ? <div className="overflow-hidden"><div className={classNames("-ml-5 -mr-5 flex overflow-scroll overflow-y-hidden", "max-[767px]:ml-0 max-[767px]:mr-0", "[&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]", "h-[425px]", {
        "overflow-scroll overflow-y-hidden flex": variant === "blog-slider" || variant === "collections-slider"
      })}>{finalSlides}</div></div> : <ForwardRefCarousel className="space-x-0 md:space-x-5" ref={carouselRef} showArrows={variant !== "blog-slider" && !(isMobile && isMobileMaterialSwatches)} arrows={<CustomCarouselArrows variant={variant} />} wrapAround={showLeftAndRightPartially ? true : finalVisibleSlides < finalSlides.length} dragging={!showLeftAndRightPartially} swiping={!disableSliding} beforeSlide={beforeSlideFn} afterSlide={afterSlideFn} scrollDistance="slide">{finalSlides}</ForwardRefCarousel>;
    $[14] = afterSlideFn;
    $[15] = beforeSlideFn;
    $[16] = disableSliding;
    $[17] = finalSlides;
    $[18] = finalVisibleSlides;
    $[19] = isMobile;
    $[20] = isMobileMaterialSwatches;
    $[21] = showLeftAndRightPartially;
    $[22] = variant;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t13 = <div className={t10}>{t11}{t12}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
export default NewSliderComponent;